<div class="timeline-wrapper" id="timeline">
    <div class="timeline">
        <div *ngFor="let milestone of lessons" class="milestone" [id]="milestone.classposition">
            <div class="circle"
                [ngStyle]="{'background-color': milestone.completed ? 'rgba(25, 135, 84, 0.5)' : 'rgba(220, 53, 69, 0.5)'}"></div>
            <div class="content d-flex flex-column justify-content-center" 
                >
                <p *ngIf="milestone.milestonetimenumber > 0 && activateLessonDeadlineNotification && enrolledDate != '0001-01-01T00:00:00'">
                    Expected to Finish: <span [ngStyle]="{'color': deadlinePassed(milestone) && !milestone.completed ? 'rgba(220, 53, 69, 0.5)': ''}">{{ setDate(milestone) | date: 'short' }} </span>
                </p>
                <h3>{{milestone.title}}</h3>
            </div>
        </div>

    </div>
</div>